import React, { useCallback, useEffect, useState } from "react";

// 3rd party Library
import PropTypes from "prop-types";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";

//style
import styles from "./style.module.scss";

const CustomTab = (props) => {
  const [activeKey, setActiveKey] = useState(props.activeKey);
  const handleTabSelect = useCallback(
    (key) => {
      setActiveKey(key);
      if (props.onTabChange) {
        props.onTabChange(key);
      }
    },
    [props.onTabChange]
  );

  useEffect(() => {
    setActiveKey(props.activeKey);
  }, [props.activeKey]);

  useEffect(() => {
    try {
      const baseId = "fill-tab-example";
      if (props.data && Array.isArray(props.data)) {
        props.data.forEach((d) => {
          const btn = document.getElementById(`${baseId}-tab-${d.key}`);
          if (btn) btn.setAttribute("data-testid", `btn-${d.key}`);
        });
      }
    } catch (e) {
    }
  }, [props.data]);

  return (
    <Tabs
      defaultActiveKey={props.activeKey}
      id="fill-tab-example"

      style={{
        top: props.top,
        zIndex: props.zInd ? props.zInd : props.top && 1000,
      }}
      className={`${props.customTab ? props.customTab : "mb-3 customTab"} ${
        styles.customTab
      } ${props.alignWithFilter === true && styles.tab_align_with_filter} ${
        props.top && styles.tab_align_top
      }`}
      fill
      onSelect={handleTabSelect}
      activeKey={activeKey}
    >
      {props.data.map((data) => (
        <Tab
          eventKey={data.key}
          data-testid={data.key}  
          title={data.text}
          key={data.key}
          disabled={data.disabled || false}
        >
          {data.function}
        </Tab>
      ))}
    </Tabs>
  );
};

CustomTab.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string.isRequired,
      function: PropTypes.element.isRequired,
      key: PropTypes.string.isRequired,
    })
  ).isRequired,
  activeKey: PropTypes.string.isRequired,
  onTabChange: PropTypes.func.isRequired,
  customTab: PropTypes.func.isRequired,
  alignWithFilter: PropTypes.func.isRequired,
  top: PropTypes.func.isRequired,
  zInd: PropTypes.number,
};

export default React.memo(CustomTab);



